import React from "react";
import styles from "../../../../Styles/TopicMetricDisplay.module.scss";

type Props = {
  metricValue: string;
  metricDescription: string;
};

export default class TopicMetricDisplay extends React.Component<Props> {
  render() {
    return (
      <div className={styles.topicMetricDisplay}>
        <p className={styles.topicMetricValue}>{this.props.metricValue}</p>
        <p className={styles.topicMetricDescription}>{this.props.metricDescription}</p>
      </div>
    );
  }
}
